import * as React from "react";
const SvgDisableW = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={13}
    fill="none"
    {...props}
  >
    <path
      stroke="#fff"
      d="M10.743 2.257a6 6 0 1 1-8.486 8.486m8.486-8.486a6 6 0 1 0-8.486 8.486m8.486-8.486-8.486 8.486"
    />
  </svg>
);
export default SvgDisableW;
